export const TOIR_SERVICE_URL = `/toro-inspection-service`
export const COMPLECTATION_SERVICE_URL = `/complectation-service`
export const SAP_LOADER_SERVICE_URL = `/toro-sap-loader`
export const MAPISSUES_CORE_URL = `/core`
export const TOIR_PLANNING_SERVICE_URL = `/toir-planning`
export const PASSPORT_REFERENCE_URL = `/passport-reference-core`
export const OSS_SERVICE_URL = `/oss`
